<template>
    <div class="start-menu-modal layout-bg">
        <div class="container">
            <div class="welcome">
                <span>
                    <h1 class="title">{{langConfig[lang].start.title}}

                    <span class="wrap-rainbow">
                        <span class="red">&nbsp;{{langConfig[lang].start.icdf[0]}}</span>
                        <span class="orange">&nbsp;{{langConfig[lang].start.icdf[1]}}</span>
                        <span class="yellow">&nbsp;{{langConfig[lang].start.icdf[2]}}</span>
                        <span class="green">&nbsp;{{langConfig[lang].start.icdf[3]}}</span>
                        <img class="vawe" :src="'../assets/img/icons/wave.gif'">
                    </span>
                    </h1>
                    
                    <p v-html="langConfig[lang].start.subtitleText" class="text"></p>
                </span>

                <div class="works">
                    <h2 class="subtitle">{{langConfig[lang].start.works.title}}</h2>
                    <ol class="list">
                        <li v-for="(i, index) in 4" :key="index" v-html="langConfig[lang].start.works.list[i-1]"></li>
                            <ul class="child-list">
                                <li><font-awesome-icon icon="eye" class="icon red"></font-awesome-icon>{{langConfig[lang].start.works.childList[0]}}</li>
                                <li><font-awesome-icon icon="question" class="icon yellow"></font-awesome-icon>{{langConfig[lang].start.works.childList[1]}}</li>
                                <li><font-awesome-icon icon="check" class="icon green"></font-awesome-icon>{{langConfig[lang].start.works.childList[2]}}</li>
                            </ul>
                        <li v-html="langConfig[lang].start.works.list[4]"></li>
                    </ol>
                </div>
                <div class="sponzors">
                    <img style="height: 35px" :src="'../assets/img/icons/weilovka.png'">
                    <img style="height: 43px" :src="'../assets/img/icons/europe.png'">
                    <img style="height: 42px" :src="'../assets/img/icons/icodethefuture.png'">
                </div>
            </div>

            <div class="start">
                <div class="hello">
                    <img class="animated-icon" :src="'../assets/img/icons/code.gif'">
                    <h1>{{langConfig[lang].start.name}}</h1>
                </div>

                <div class="input">
                    <span>{{langConfig[lang].start.name}}</span>
                    <input placeholder="James Doe" class="name" type="text" v-model="name">
                    <span @click="enterGame()" class="button">{{langConfig[lang].start.startGame}}</span>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
import configLang from "../assets/config.json";
    export default {
        props: ["lang"],
        data() {
            return {
                langConfig: configLang,
                name: null,
            }
        },
        methods: {
            enterGame() {
                if(this.name != null) {
                    this.$parent.name = this.name;
                    this.$parent.modalIsOpen = false;
                }
            }
        }
    };
</script>

<style lang="scss">

.disabled {
    opacity: 0.6;
}

.layout-bg{
    background: rgba(0, 0, 0, 0.842);
    width: 100%;
    height: 100%;

    overflow-y: auto;

    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;

    display: flex;
    justify-content: center;
    align-items: center;
    
    padding: 30px;
}

.start-menu-modal{
    .container{
        width: 100%;
        max-width: 1400px;
    
        display: flex;
        align-items: row;
        gap: 10px;
    }

    .welcome{
        background: #fff;
        border-radius: 15px;
        // height: 100%;
        // width: 65%;
        flex-grow: 1;
        width: 100%;
        padding: 30px;

        display: flex;
        flex-direction: column;
        gap: 30px;

        .title {
            display: flex;
            align-items: center;
            font-size: 28px;
            font-weight: bolder;

            .wrap-rainbow{
                display: flex;
                align-items: center
            }

            .vawe{
                height: 50px;
            }

            .red{
               color: #A35353; 
            }

            .orange{
                color: #C85515;
            }

            .yellow{
                color: #D79B41;
            }

            .green{
                color: #2E9C24;
            }
        }

        .text{
            font-size: 19px;
            text-align: justify;

            .bold{
                color: rgb(54, 53, 53);
                font-weight: 600;
            }
        }

        strong{
            .btn{
                background-color: #4CAF50;
                text-align: center;
                border-radius: 22px;
                padding: 4px 10px;
                color: white;
                border: none;
                cursor: pointer;
                font-style: normal;
                font-weight: 500;
                font-size: 14px;
            }

            .br5 {
                border-radius: 10px !important;
            }
        }

        .works{
            display: flex;
            flex-direction: column;
            margin-top: 15px;
            margin-bottom: 15px;

            .subtitle{
                height: 35px;
            }

            .list{
                font-size: 19px;
                margin-left: 18px;

                .btn{
                    background-color: #4CAF50;
                    text-align: center;
                    border-radius: 22px;
                    padding: 5px 12px;
                    color: white;
                    border: none;
                    cursor: pointer;
                    font-style: normal;
                    font-weight: 500;
                    font-size: 16px;
                }

                .btn:hover{
                    background-color: #45a049;
                    cursor: pointer;
                }
                .child-list{
                    list-style-type: none;
    
                    li {
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        margin-top: 5px;
                    }  
                
                    li .icon {
                        height: 20px;
                        background: #363636;
                        border-radius: 5px;
                        padding: 5px;
                        display: flex;
                        width: 22px;
                    }

                    li .red {
                        color: #E25C00;
                        :hover {
                            color: rgb(237, 131, 61);
                            cursor: pointer;
                        }
                    }

                    li .yellow {
                        color: #FAE400;
                        :hover {
                            color: #f3eeb4;
                            cursor: pointer;
                        }
                    }

                    li .green {
                        color: #9EC000;
                        :hover {
                            color: #b2d905;
                            cursor: pointer;
                        }
                    }
                }
            }

            li:not(:last-child) { 
                margin-bottom: 4px;  
            }

            .bold {
                color: rgb(54, 53, 53);
                font-weight: 600;
            }
        }

        .sponzors{
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 10px;
        }
    }

    .start{
        // height: 10;
        flex-shrink: 1;
        padding: 20px 30px;
        background: #fff;
        border-radius: 15px;

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 50px;
    
        h1{
            text-align: center;
        }
    
        .animated-icon {
            width: 125px;
        }
        
        .hello {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
        }

        .input {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            gap: 15px;

            .name {
                height: 40px;
                padding: 8px 16px;
                font-size: 14px;
                font-weight: 500;
                font-family: inherit;
                border-radius: 4px;
                border: 1px solid #cdedd9;
                margin-left: 15px;
            }

            .button {
                background-color: #4CAF50; 
                color: white; 
                border: none;
                border-radius: 5px;
                padding: 10px 20px; 
                cursor: pointer; 
                
              }
              
              .button:hover {
                background-color: #45a049;
              }
              
              .button:focus {
                outline: none;
              }
        }
    }
}

@media only screen and (max-width: 1500px),
only screen and (max-height: 800px){
    li, span, .text, strong{
        font-size: 14px !important;
    }

    .title{
        font-size: 25px !important;

        span{
            font-size: 25px !important;
        }
    }

    h1{
        font-size: 25px;
    }

    .subpage{
        font-size: 20px !important;
    }

    .start-menu-modal{
        align-items: flex-start;
    
        .container{
            flex-direction: column;
            max-width: 800px;
        }
    }
}

@media only screen and (max-width: 800px){
    .title{
        flex-direction: column;;
    }

    .list{
        line-height: 20px;
    }
}

</style>